import { Loader2 } from 'lucide-react';
import { cn } from '../lib/cn';

const sizeMap = {
  sm: 'h-4 w-4',
  md: 'h-5 w-5',
  lg: 'h-6 w-6',
  xl: 'h-10 w-10',
} as const;

export interface SpinnerProps {
  size?: keyof typeof sizeMap;
  className?: string;
  label?: string;
}

export function Spinner({ size = 'md', className, label = 'Loading' }: SpinnerProps) {
  return (
    <span role="status" className={cn('inline-flex items-center gap-2', className)}>
      <Loader2 className={cn('animate-spin text-text-secondary', sizeMap[size])} aria-hidden="true" />
      <span className="sr-only">{label}</span>
    </span>
  );
}
